import { useNavigate } from "react-router-dom";
import { ArrowRightCircleIcon, CheckBadgeIcon } from "@heroicons/react/24/solid";
import ProgressBar from "../../../components/ProgressBar";
import { PromptSteps } from "../../prompts/AddEditPrompt";

interface ProgressSectionProps {
	id: number;
	started: number;
	completed: number;
	assigned: number;
	allComplete: boolean;
	isReviewsCard: boolean;
	isLessonsCard: boolean;
	allowReviews: boolean;
	promptId?: number;
}

export default function ProgressSection(props: ProgressSectionProps) {
	const navigate = useNavigate();

	return (
		<div>
			{props.assigned > 0 ? (
				props.allComplete ? (
					<div className="items-center text-green-700 inline-flex float-right">
						<CheckBadgeIcon className="mr-1.5 h-7 w-7" aria-hidden="true" />
						<p>
							<strong>
								{props.completed}
								<span className="text-xs">/{props.assigned}</span>
							</strong>{" "}
							complete!
						</p>
					</div>
				) : props.completed == 0 ? (
					<div className="w-full">
						<ProgressBar
							id={props.id}
							started={props.started}
							showStartedOnly={true}
							assigned={props.assigned}
							barColor="bg-zinc-400"
						/>
						<p className="text-gray-500 text-sm text-right pt-0.5">
							<strong>
								{props.started}
								<span className="text-xs">/{props.assigned}</span>
							</strong>{" "}
							students have started
						</p>
					</div>
				) : (
					<div className="w-full">
						<ProgressBar
							id={props.id}
							started={props.started}
							completed={props.completed}
							assigned={props.assigned}
							completedLabel={
								props.isLessonsCard
									? "Completed"
									: props.isReviewsCard
										? "Submitted"
										: "Last Draft Scored"
							}
						/>
						<p className="text-gray-500 text-sm text-right pt-0.5">
							<strong>
								{props.completed}
								<span className="text-xs">/{props.assigned}</span>
							</strong>{" "}
							students{" "}
							{props.isLessonsCard
								? "have completed"
								: props.isReviewsCard
									? "have submitted"
									: "with last draft scored"}
						</p>
					</div>
				)
			) : props.isReviewsCard ? (
				props.allowReviews ? (
					<p className="text-sm text-center text-gray-500">
						No students have requested peer reviews yet.
					</p>
				) : (
					<div className="flex items-center justify-between">
						<p className="text-sm text-gray-500 w-5/6">
							Turn on peer reviews for this prompt.
						</p>
						<ArrowRightCircleIcon
							className="size-8 w-1/6 hover:cursor-pointer text-primary-700"
							onClick={() => {
								navigate(`/writing/prompt?promptId=${props.promptId}`, {
									state: {
										step: PromptSteps.PeerReviews,
									},
								});
							}}
						/>
					</div>
				)
			) : (
				<></>
			)}
		</div>
	);
}
